// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1f840ba8","239":"fcaddd2b","488":"e75445ad","732":"957a1922"}[chunkId] + ".chunk.js";
};